module.exports = __webpack_public_path__ + "a945972ac584f28907769039433e1437.png";